// check for supported browsers (Chrome, Opera, Edge, Brave, Firefox)
export function isSupportedBrowser() {
	const isChrome = navigator.userAgent.indexOf("Chrome") != -1;
	const isOpera = (navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf("OPR")) != -1;
	const isEdge = navigator.userAgent.indexOf("Edg") != -1;
	const isBrave = navigator.userAgent.indexOf("Brave") != -1;
	const isFirefox = navigator.userAgent.indexOf("Firefox") != -1;

	return isChrome || isOpera || isEdge || isBrave || isFirefox;
}
